export default {
  title: 'Nebula buds AI कॉल', // "Nebula buds AI通话" 翻译为印地语
  userID: 'उपयोगकर्ता आईडी : ', // "用户ID : "
  hurryUp: 'दूसरे पक्ष के कॉल का इंतजार', // "等待对方呼叫"
  waitingCall: 'इस पृष्ठ पर दूसरे पक्ष के कॉल का इंतजार करें, कृपया पृष्ठ को जल्दी बंद न करें।', // "在此页面等待对方拨打电话，请勿提前关闭。"
  subSwitch: 'सबटाइटल स्विच', // "字幕开关"
  initWait: 'प्रारंभिक सेटअप का इंतजार', // "等待初始化"
  initSuccess: 'प्रारंभिक सेटअप पूरा, दूसरे पक्ष के कॉल का इंतजार करें। कृपया पृष्ठ को बंद न करें!', // "初始化完成，等待对方呼叫。请勿关闭页面！"
  callStart: 'कॉल कनेक्टेड', // "电话接通"
  callEnd: 'कॉल समाप्त', // "通话结束"
  careful: 'ध्यान दें : ', // "注意 : "
  wait: 'कॉल घटक तैयार है, दूसरे पक्ष के कॉल का इंतजार करें', // "通话组件已准备好,等待对方拨打电话"
  langSwitch: {
    ar: 'अरबी', // "阿拉伯语"
    da: 'डेनिश', // "丹麦语"
    de: 'जर्मन', // "德语"
    en: 'अंग्रेजी', // "英语"
    es: 'स्पैनिश', // "西班牙语"
    fil: 'फिलीपिनो', // "菲律宾语"
    fr: 'फ्रेंच', // "法语"
    hi: 'हिंदी', // "印地语"
    id: 'इंडोनेशियाई', // "印度尼西亚语"
    it: 'इतालवी', // "意大利语"
    ja: 'जापानी', // "日文"
    ko: 'कोरियाई', // "韩语"
    ms: 'मलय', // "马来语"
    no: 'नॉर्वेजियन', // "挪威语"
    pt: 'पोर्तुगीज', // "葡萄牙语"
    ru: 'रूसी', // "俄语"
    sv: 'स्वीडिश', // "瑞典语"
    th: 'थाई', // "泰语"
    tr: 'तुर्की', // "土耳其语"
    vi: 'वियतनामी', // "越南语"
    zh: 'चीनी' // "中文"
  }
}
